import { Dispatch, MouseEvent, SetStateAction } from "react";
import styled from "styled-components";
import css from "@styled-system/css";

type StyledDropdownOptionProps = {
  name: string;
  active: boolean;
  onClick: (e: MouseEvent<HTMLElement>) => void;
  setHovered: Dispatch<SetStateAction<undefined | string>>;
};

const StyledLi = styled.li`
  display: flex;
  color: #3f403f;
  cursor: pointer;
  white-space: nowrap;
  ${css({
    "&:hover": {
      color: "primary-light-blue",
      textDecoration: "underline",
    },
    "&.active": {
      color: "primary-light-blue",
      textDecoration: "underline",
    },
    lineHeight: ["40px", "24px"],
  })}
`;

export default function DropdownOption({
  name,
  active,
  onClick,
  setHovered,
}: StyledDropdownOptionProps) {
  return (
    <StyledLi
      role="menuitem"
      className={active ? "active" : ""}
      onClick={onClick}
      onMouseEnter={() => setHovered(name)}
      onMouseLeave={() => setHovered(undefined)}
    >
      {name}
    </StyledLi>
  );
}
